import {
	HoverCard,
	HoverCardContent,
	HoverCardTrigger,
} from "@/components/ui/hover-card";
import { useMobile } from "@/hooks/useMedia";
import { AuthHoc } from "@/lib/auth/hoc";
import { cn } from "@/lib/utils";
import { m } from "@/paraglide/messages";
import { localizeHref } from "@/paraglide/runtime";
import { MemberLevel } from "@/routes/$lang/profile/-api";
import { Link } from "@tanstack/react-router";
import { ProfileNav } from "~/components/business/profileNav";
import { Level1Icon, Level2Icon, Level3Icon } from "../icons";
import { Button } from "../ui/button";

const levelIconMap = {
	[MemberLevel.STANDARD]: Level1Icon,
	[MemberLevel.PREMIUM]: Level2Icon,
	[MemberLevel.SUPREME]: Level3Icon,
} as Record<MemberLevel, typeof Level1Icon>;
const levelBorderMap = {
	[MemberLevel.STANDARD]: "border-2 border-[#BE7E3A]",
	[MemberLevel.PREMIUM]: "border-2 border-[#7D767D]",
	[MemberLevel.SUPREME]: "border-2 border-[#FFCC57]",
} as Record<MemberLevel, string>;

export function Account() {
	const isMobile = useMobile();
	return (
		<div>
			<AuthHoc>
				{({ user, doLogin }) => {
					const hasUser = !!user?.user_id;
					const LevelIcon = user?.member_level
						? levelIconMap[user.member_level as MemberLevel]
						: null;
					const borderClass = user?.member_level
						? levelBorderMap[user.member_level as MemberLevel]
						: "";
					return (
						<HoverCard>
							<HoverCardTrigger asChild>
								<Link
									to={
										isMobile
											? localizeHref("/profile")
											: localizeHref("/profile/account")
									}
									onClick={(e: { preventDefault: () => void }) => {
										if (!hasUser) {
											e.preventDefault();
											doLogin();
										}
									}}
								>
									{user?.name ? (
										<div className="flex items-center gap-2 max-md:gap-3.5 relative">
											<div className="relative">
												{LevelIcon && (
													<LevelIcon className="w-9 h-auto absolute -top-2.5 -right-3 scale-50 rotate-30" />
												)}
												<img
													src={user.avatar}
													alt="avatar"
													className={cn(
														"w-9 h-9 min-w-9 min-h-9 rounded-full object-cover",
														borderClass,
													)}
												/>
											</div>

											<p className="text-t1 max-w-[100px] line-clamp-1 max-md:hidden text-ellipsis truncate">
												{user.name}
											</p>
										</div>
									) : (
										<Button className="md:w-30 w-20 rounded-full h-9 text-sm">
											<m.login />
										</Button>
									)}
								</Link>
							</HoverCardTrigger>
							{hasUser && !isMobile && (
								<HoverCardContent className="w-full bg-transparent border-none shadow-none p-0 pt-2  pr-6">
									<ProfileNav className="rounded-lg" />
								</HoverCardContent>
							)}
						</HoverCard>
					);
				}}
			</AuthHoc>
		</div>
	);
}
